import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { BottomNav } from './BottomNav';
import { usePreferencesSync } from '@/hooks/use-preferences';

export function AppLayout() {
  usePreferencesSync();
  return (
    <div className="flex h-screen w-full bg-background">
      {/* Sidebar — hidden on mobile */}
      <div className="hidden md:block">
        <AppSidebar />
      </div>

      <main className="flex-1 overflow-auto pb-16 md:pb-0">
        <div className="p-4 md:p-6">
          <Outlet />
        </div>
      </main>

      {/* Bottom nav — visible on mobile only */}
      <BottomNav />
    </div>
  );
}
